<div class="animated fadeInRight">
  <app-lfsa-card-v2
    [titulo]="'Carga de Matriz QM'"
    [modulo]="'PLM Calidad'"
    [tituloCard]="'Validación y Carga'"
    [innTemplate]="enviarTemplateEdit"
    [innTemplateButton]="innTemplateButton">
  </app-lfsa-card-v2>

  <!-- Botonera -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <app-lfsa-options-export (devolverAccionExport)="downloadCsvFormato()"></app-lfsa-options-export>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #enviarTemplateEdit>
    <hr>
    <p *ngIf="!displayPreview">Seleccione o arrastre el archivo nombre.CSV con la información a registrar en la Matriz QM.</p>
    <p> USUARIO ACTUAL: {{this.usarioActual}} </p>

    <!-- Formulario de Carga -->
    <div *ngIf="displayForm" >
      <!-- Upload Control arrastrar y soltar -->
      <section class="view active" id="view-carga">
        <div class="panel">
          <div class="panel-body">       
            <div class="dropzone" #dropzone (dragover)="dragOver($event)" (dragleave)="dragLeave()" (drop)="drop($event)">   
              <i class="fa-solid fa-cloud-arrow-up"></i>
              <p class="mt-3 mb-1 fw-semibold">Arrastre aquí su archivo, o</p>
              <button class="btn btn-lg btn-primary" (click)="similaInteraccionCarga()"><i class="bi bi-folder2-open me-1"></i>Seleccionar archivo</button>
              <input type="file" id="csvInput" accept=".csv" hidden (change)="onUpload($event)" #fileInput accept=".csv" />
              <p class="text-muted mt-3 mb-0" style="font-size:.8rem;">Formatos permitidos: .csv</p>
            </div>
            
            <div class="alert alert-warning alert-dismissible fade show mt-2" role="alert" *ngIf="uploadedFiles.length">
              Archivo cargado {{uploadedFiles[0].name}} <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          </div>
        </div>
      </section>
    </div>
    
    <!-- Acciones de previsualizacion, antes de procesar -->
    <div *ngIf="displayPreview" class="mt-4 mb-4">
      <h6>{{Titulo_Grid}}</h6>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <ag-grid-angular class="ag-theme-balham"
                      style="width: 100%; height: 400px;"
                      [rowData]="data"
                      [columnDefs]="columnDefs"
                      [pagination]="true"
                      [paginationPageSize]="20">
      </ag-grid-angular>

      <!-- Acciones de previsualizacion, antes de procesar -->
      <div class="d-flex justify-content-end mt-4 m-4" *ngIf="!displayValidacion">
        <button type="button" class="btn btn-outline-danger" style="margin-right: 10px;" (click)="reset()"><i class="fa fa-times"></i> Cancelar</button>
        <button type="button" class="btn btn-outline-primary" (click)="preCargaData()" ><i class="fa fa-check"></i> Enviar</button>
      </div>

      <!-- Acciones de Validacion, para guardar registros -->
      <div class="row mt-4 mb-4" *ngIf="displayValidacion">
        <div class="form-group col-md-12"><app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2></div>

        <div class="form-group col-md-6">
          <button type="button" class="btn btn-outline-danger btn-block btn-lg" (click)="regresar()">Regresar</button>
        </div>

        <div class="form-group col-md-6">
          <button type="button" class="btn btn-outline-success btn-block btn-lg" [disabled]="errorData" (click)="guardar()"><i class="fa fa-check"></i>Guardar</button>
        </div>
      </div>
    </div>

  </ng-template>

</div>